module.exports = __webpack_public_path__ + "static/media/het_gezin_met_hond.77cf9806.jpg";